import React, { lazy } from "react";

const LazyOutcomeOverview = lazy(() => import("./OutcomeOverview"));

const OutcomeOverview = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyOutcomeOverview {...props} />;

export default OutcomeOverview;
